const PREFIXES = [
  {
    slug: "burning",
    name: "Burning",
    tint: "red",
    statDeltas: [{ stat: "redColor", value: 5 }],
    rarityBump: 1,
    addIfHasAction: {
      sword_slash: "flame_slash",
      sword_slash_2h: "flame_slash_2h",
      axe_swipe: "flame_cleave",
      arrow_shot: "fire_arrow",
      dagger_stab: "flame_stab"
    }
  },
  {
    slug: "dark",
    name: "Dark",
    tint: "black",
    statDeltas: [{ stat: "blackColor", value: 5 }],
    rarityBump: 1,
    addIfHasAction: {
      sword_slash: "shadow_slash",
      sword_slash_2h: "shadow_slash_2h",
      arrow_shot: "shadow_arrow",
      dagger_stab: "shadow_stab",
      axe_swipe: "shadow_cleave"
    }
  },
  {
    slug: "crackling",
    name: "Crackling",
    tint: "blue",
    statDeltas: [{ stat: "blueColor", value: 5 }],
    rarityBump: 1,
    addIfHasAction: {
      sword_slash: "static_slash",
      sword_slash_2h: "static_slash_2h",
      axe_swipe: "volt_cleave",
      arrow_shot: "arcane_arrow",
      dagger_stab: "static_stab"
    }
  },
  {
    slug: "venomous",
    name: "Venomous",
    tint: "green",
    statDeltas: [{ stat: "greenColor", value: 5 }],
    rarityBump: 1,
    addIfHasAction: {
      sword_slash: "nature_slash",
      sword_slash_2h: "nature_slash_2h",
      axe_swipe: "tree_chop",
      arrow_shot: "poison_dart",
      dagger_stab: "needle_pierce"
    }
  },
  {
    slug: "radiant",
    name: "Radiant",
    tint: "gold",
    statDeltas: [{ stat: "goldColor", value: 5 }],
    rarityBump: 1,
    addIfHasAction: {
      sword_slash: "radiant_slash",
      sword_slash_2h: "radiant_slash_2h",
      axe_swipe: "radiant_cleave",
      arrow_shot: "radiant_arrow",
      dagger_stab: "radiant_stab"
    }
  }
];
export {
  PREFIXES
};
//# sourceMappingURL=data:application/json;base64,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
